export default __webpack_public_path__ + "static/media/Professional Profile Flipped.a07c49af.jpg";